import React from "react";
import * as Sentry from "@sentry/react";
import statusJson from "./status.json";

if (import.meta.env.VITE_DEPLOY_TARGET) {
  let dsn = "https://545ee625546e4c0e966d6ad452201986@o60106.ingest.sentry.io/5401410";
  if (import.meta.env.VITE_DEPLOY_TARGET === "production") {
    dsn = "https://ec2e92c54a6843a896f40aa5c8837694@o60106.ingest.sentry.io/5401406";
  }
  Sentry.init({
    dsn,
    release: statusJson.release,
  });
}

type Props = {
  children: React.ReactElement;
};

const fallbackComponent = (
  <div style={{ padding: "20px", textAlign: "center" }}>エラーが発生しました。画面を再読み込みしてください。</div>
);

export const SentryWrapper = (props: Props): React.ReactElement => {
  if (!import.meta.env.VITE_DEPLOY_TARGET) {
    return props.children;
  }
  return <Sentry.ErrorBoundary fallback={fallbackComponent}>{props.children}</Sentry.ErrorBoundary>;
};
